import { Currency } from '@/core/currency/interfaces';

const CAD: Currency = {
    name: 'Canadian Dollar',
    demonym: 'Canadian',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '124',
    symbol: 'CA$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'CAD',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default CAD;
